import React from 'react';
import Stylesheet from './Profile.module.css';
import Image from '../../../elements/Image/Image';
import Button from '../../../elements/Button/Button';
import Input from '../../../elements/Input/Input';
import Email from '../../../elements/Email/Email';
import DropMenu from '../../../elements/DropMenu/DropMenu';
import Default from '../../../assets/profile.png';
import {UserContext} from '../../../contexts/user';
import {user} from '@enigma/core/services';
import { AppContext } from '../../../contexts/app';
import {ico_clipboard_check, ico_envelope, 
    ico_key, ico_user_lock, ico_user_tie, ico_times} from '../../../icon';

const Profile = (props) => {
    document.title = `Profile - ${user.displayName}`;
    let metadata = null;
    let app = null;
    const init = (userContext, appContext) => {
        metadata = userContext;
        app = appContext;
    }
    const updateEmail = async (newEmail) => {
        const response = await app.toggleMessageBox("confirm your password", 
        "for security reasons, please re-enter your current password.", "authenticate");
        if (response !== "cancled") 
            user.current.updateEmail(newEmail)
            .then(_ => app.toggleToast(ico_envelope, "email successfully changed"))
            .catch(_ =>app.toggleToast(ico_envelope, "email coud not be changed", true))
    }
    const sendPasswordChangeEmail = () => {
        user.sendPasswordResetEmail()
        .then(_=> app.toggleToast(ico_envelope, "Request has been sent, "+
        "please check your inbox for further instructions."))
        .catch(_ => app.toggleToast(ico_times, "email could not be send, check your "+
        "internet connection and try again.", true))
    }
    const generateAuthorizationKey = async () => {
        const key = await user.generateAuthorizationKey();
        var tempInput = document.createElement("input");
        tempInput.value = key;
        tempInput.style.opacity = "0";
        document.body.appendChild(tempInput);
        tempInput.select();
        document.execCommand("copy");
        document.body.removeChild(tempInput);
        app.toggleToast(ico_clipboard_check, "authorization key coppied to clipboard");
    }
    const header = () => {
        return (
            <div className={Stylesheet.Header}>
                <div className={Stylesheet.ProfileImg}>
                    <Image 
                    src={Default} 
                    url="static" 
                    alt="user profile image" />
                </div>
                <h2>{metadata.firstName}&nbsp;
                {metadata.otherName}&nbsp;
                {metadata.lastName}</h2>
                <h4>{user.email}</h4>
                <h4>{metadata.branch} &middot; {metadata.role}</h4>
            </div>
        )
    }

    const controls = () => {
        return (
            <div className={Stylesheet.Controls}>
                {user.isEmailVerified ? null
                :<Button onClick={_ => 
                user.sendEmailVerification()
                .then(_ => app.toggleToast(ico_envelope, 
                "verification email sent. check your inbox for further instructions."))
                } secondary>
                send verfication email</Button>}
                {metadata?.admin
                ? <Button 
                    disabled={!user.isEmailVerified}
                    onClick={async _ => generateAuthorizationKey()}>
                {ico_key}&emsp;generate auth key</Button>
                : null}
                <Button onClick={_ => sendPasswordChangeEmail()}>
                {ico_key}&emsp;change password</Button>
                <Button secondary onClick={_ => user.signOut()}>
                log out</Button>
            </div>
        )
    }

    const customization = () => {
        return (
            <div className={Stylesheet.Customization}>
                <h5 className={Stylesheet.Title}>{ico_user_tie}&emsp;user profile</h5>
                <div className={Stylesheet.Fieldset}>
                    <div className={Stylesheet.Field}>
                        <Input defaultValue={metadata.firstName} disabled />
                    </div>
                    <div className={Stylesheet.Field}>
                        <Input defaultValue={metadata.otherName} disabled />
                    </div>
                    <div className={Stylesheet.Field}>
                        <Input defaultValue={metadata.lastName} disabled />
                    </div>
                    <div className={Stylesheet.Field}>
                    <DropMenu default={metadata.branch} disabled values={[
                        "suva", 
                        "nadi",
                        "lautoka",
                        "sigatoka",
                        "ba",
                        "tavua",
                        "Rakiraki",
                        "labasa"
                    ]}
                    onChange={value => console.log(value)} />
                    </div>
                    <div className={Stylesheet.Field}>
                    <DropMenu default={metadata.role} disabled values={[
                        "administration",
                        "branch manager",
                        "IT support",
                        "data entry clerk",
                        "audit officer"
                    ]}
                    onChange={value => console.log(value)} />
                    </div>
                </div>
                <h5 className={Stylesheet.Title}>
                {ico_user_lock}&emsp; user security ~ update email address</h5>
                <div className={Stylesheet.Fieldset}>
                    <div className={Stylesheet.Field}>
                        <Email icon defaultValue={user.email} 
                        domain='gmgroup.com.fj'
                        onBlur={value => updateEmail(value)} />
                    </div>
                </div>
            </div>
        )
    }

    return (
        <UserContext.Consumer>
            {user => (
                <AppContext.Consumer>
                    {app => (
                        <div className={Stylesheet.Container}>
                            {init(user.profile, app)}
                            {header()}
                            {controls()}
                            {customization()}
                        </div>
                    )}
                </AppContext.Consumer>
            )}
        </UserContext.Consumer>
    )
}

export default Profile;